import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import {
    Button,
    InlineLoading,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableHeader,
    TableCell,
    Tile,
  } from 'carbon-components-react';
import View16 from '@carbon/icons-react/lib/view/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import FileUpload from '../../../common/FileUpload';
import DownLoadButton from '../../../common/FileDownloadButton';
import { Online, Offline } from '../../../common/OnLineOffLine';
import { NoRecordsPlaceholder } from '../../../../helpers/jsonschemaform/DataTableExtention';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import { getError, apioperation, entitiesLabels, sizeFormat } from '../../../../helpers/Constants';

const DrillReportSignedAttachment = ({ onUpload, 
    deleteSignedAttachment, 
    drillReportId, 
    editingDisabled, 
    signedAttachmentsArray }) => {
    const [modalDeleteAttachmentVisible, setModalDeleteAttachmentVisible] = useState(false);
    const [selectedDeleteAttachment, setSelectedDeleteAttachment] = useState(null);
    const [downloadingItemId, setDownlodingItemId] = useState(null);
    const [signedAttachments, setSignedAttachements] = useState(signedAttachmentsArray);

    useEffect(() => { setSignedAttachements(signedAttachmentsArray); }, [signedAttachmentsArray]);

    // *************** ATTACHMENT *************** START
    const handleDeleteAttachmentModalVisibility = () => {
        setModalDeleteAttachmentVisible(!modalDeleteAttachmentVisible);
        setSelectedDeleteAttachment(null);
    };
    
    const showDeleteAttachmentModal = (Id) => {
        const selectedItem = signedAttachments.find((item) => item.idAttachment === Id);
        setSelectedDeleteAttachment(selectedItem);
        setModalDeleteAttachmentVisible(!modalDeleteAttachmentVisible); 
    };
    
    const deleteAttachment = () => {
        deleteSignedAttachment(selectedDeleteAttachment.idAttachment);
        handleDeleteAttachmentModalVisibility();
    };
    
    const renderDeleteAttachmentModal = () => modalDeleteAttachmentVisible && (
    <div className="bx--modal bx--modal-tall is-visible">
      <div className="bx--modal-container">
        <div className="bx--modal-header">
          <h3 className="bx--modal-header__heading">Delete Attachment</h3>
          <Button
            className="bx--modal-close"
            renderIcon={Close16}
            onClick={() => handleDeleteAttachmentModalVisibility()}
          />
        </div>
    
        <div className="bx--modal-content">
          <div className="bx--row bx--modal-content-detail">
            <div className="bx--col-lg-12 bx--col-md-12">
              <h5 className="align-center">
                {`Press confirm to delete ${selectedDeleteAttachment?.attachment.name}`}
              </h5>
            </div>
          </div>
        </div>
        <div className="bx--modal-footer">
          <Button
            className="button--max-width"
            kind="secondary"
            onClick={() => handleDeleteAttachmentModalVisibility()}
          >
            Cancel
          </Button>
          <Button 
            className="button--max-width" 
            kind="primary" 
            onClick={() => deleteAttachment()}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
    );
    // *************** ATTACHMENT *************** END

    return (
      <>
        {renderDeleteAttachmentModal()}
        <Tile className="bx--tile bx--tile--light">
          {!editingDisabled ? (
            <div className="bx--col-lg-6 bx--col-md-6">
              <FileUpload
                Container="saipem"
                StoragePath="drillReport"
                onUpload={onUpload}
                disabled={editingDisabled}
                customMainDescription="Upload in this section the Drill Reports with collected signatures" 
              />
            </div>
            ) : (
                ''
            )}
        </Tile>
        <Tile className="bx--tile bx--tile--light">
          <div className="bx--col-lg-12 bx--col-md-12">
            <TableContainer className="bx--grid--full-width">
              <Table>
                <TableHead className="colorgray">
                  <TableRow>
                    <TableHeader>Name</TableHeader>
                    <TableHeader>Size</TableHeader>
                    <TableHeader className="align-center">Actions</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {signedAttachments < 1 ? (
                    <NoRecordsPlaceholder
                      labelText="No Records"
                      title="&#9888; It is forbidden to upload photos wich show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people"
                      colSpan={3} 
                    />
                    ) : (
                        signedAttachments.map((item) => (
                          <TableRow
                            key={`row_${item.idAttachment}`}
                            title="&#9888; It is forbidden to upload photos wich show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people"
                          >
                            <TableCell key={`cell_1_${item.idAttachment}`}>{item.attachment?.name}</TableCell>
                            <TableCell key={`cell_2_${item.idAttachment}`}>
                              {sizeFormat(item.attachment?.size)}
                            </TableCell>
                            <TableCell key={`action-${item.idAttachment}`} className="tableActions align-center">
                              {downloadingItemId === item.idAttachment ? (
                                <div>
                                  <InlineLoading
                                    description=""
                                    iconDescription="downloading.."
                                    status="active" 
                                  />
                                </div>
                                ) : (
                                  <div>
                                    <Online>
                                      <DownLoadButton
                                        onError={(error) => {
                                            showNotification.error(
                                                `${entitiesLabels.ERROR}`,
                                                getError(error, 
                                                        entitiesLabels.FileUpload, apioperation.GET)
                                            );
                                        }}
                                        onDownLoadStart={() => 
                                          setDownlodingItemId(item.idAttachment)}
                                        onDownLoadEnd={() => setDownlodingItemId(null)}
                                        apiUrl={`/drill/report/${drillReportId}/signedattachment/${item?.attachment?.fileIdentifier}`}
                                        fileName={item?.attachment?.name}
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Download"
                                        kind="ghost"
                                        disabled={editingDisabled}
                                      />
                                    </Online>
                                    <Offline>
                                      <Button
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Download"
                                        kind="ghost"
                                        disabled 
                                      />
                                    </Offline>
                                    <Online>
                                      <Button
                                        onClick={() => showDeleteAttachmentModal(item.idAttachment)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                        disabled={editingDisabled}
                                      />
                                    </Online>
                                    <Offline>
                                      <Button
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                        disabled 
                                      />
                                    </Offline>
                                  </div>
                                )
                              }
                            </TableCell>
                          </TableRow>
                          ))
                        )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Tile>
      </>
    );
};

DrillReportSignedAttachment.propTypes = {
    deleteSignedAttachment: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    editingDisabled: PropTypes.bool.isRequired,
    drillReportId: PropTypes.string.isRequired,
    signedAttachmentsArray: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      contentType: PropTypes.string,
      size: PropTypes.string,
      fileIdentifier: PropTypes.string,
      filePath: PropTypes.string,
      type: PropTypes.string,
    })).isRequired,
};

export default DrillReportSignedAttachment;
